<div class="modal-header align-items-start p-0 border-bottom-0 d-flex mb-8 justify-content-between flex-sm-row-reverse">
    <div>
      <button type="button" class="btn-close btn-neutral btn-square"
        aria-label="Close" (click)="close()"></button>
    </div>
    <div class="text-dark align-items-center d-flex flex-column">
      <label class="pt-2 title">Missing Timesheets</label>
    </div>
    <div class="transparent"></div>
  </div>
 
  <div class="modal-body p-0">
    <table matSort class=" table table-borderless datatable">
        <thead class="table-light">
            <tr>
                <th scope="col">Contractor</th>
                <th scope="col">Job</th>
                <th scope="col">Client</th>
                <th scope="col">Send Reminder</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let missingTimesheet of allMissingTimesheets; let i = index" class="dataColumn">
                <td>
                    <div class="textWithIcon">
                        <div class="avatar avatar-sm bg-warning rounded-circle text-white h-7 w-7 me-2"
                            *ngIf="missingTimesheet.profile_pic">
                            <img alt="..." src="{{dataSharedService.getImage(missingTimesheet.profile_pic)}}">
                        </div>
                        <div *ngIf="!missingTimesheet.profile_pic" class="cotractorInitialIcon bg-primary bg-opacity-20 h-7 w-7">
                            <span class="text-primary fs-10x">{{authService.getInitials(missingTimesheet.candidate)}}</span>
                        </div>
                        <span>{{missingTimesheet.candidate}}</span>
                    </div>
                </td>
                <td>{{missingTimesheet.job}}</td>
                <td>{{missingTimesheet.client}}</td>
                <td>
                    <button type="button" (click)="openSendReminderPopUp(missingTimesheet.candidate_uuid, missingTimesheet.candidate_first_name, missingTimesheet.job, missingTimesheet.client)" class="btn btn-sm btn-square btn-neutral text-danger-hover">
                        <i class="bi bi-envelope"></i>
                    </button>
                </td>
            </tr>
        </tbody>    
    </table>
  </div>
 